import { ClaimReservationResponse } from '@interaction-gaming/player-data-service-browser-client'
import './status-screen.scss'

import DetailsBackground from '@Assets/confirmation-background.png'
import { ComponentUtils } from '@Components/utils'
import { Button } from '@Components/button/button'
import { Header } from '@Components/header/header'
import { useLocation, useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { RootState } from '@AppState/redux-store'
import { ImageBackgroundSection } from '@Components/image-background-section/image-background-section'
import { AlreadyCancelledScreen } from './already-cancelled-screen'
import { hostConfigByName } from '../../config/utils'
import { QUERY_PARAMS, FLOWS } from '../../constants'

const CLASS_NAME = 'status-screen'

export type EditReservationScreenProps = {
  reservation: ClaimReservationResponse
}
export const EditReservationScreen = ({ reservation }: EditReservationScreenProps) => {
  const dateInfo = reservation.timeslot.display.dateComponents

  const navigate = useNavigate()
  const routerLocation = useLocation()

  const hostName = useSelector((state: RootState) => state.appConfig.config?.hostName)
  const enableClaimForm = useSelector((state: RootState) => state.appConfig.config?.enableClaimForm)

  if (reservation.claimReservationDetails.isCancelled) {
    return <AlreadyCancelledScreen />
  }

  if (!hostName) {
    throw new Error('Unable to determine host name')
  }
  const hostConfig = hostConfigByName[hostName]
  const showClaimFormCta = !!enableClaimForm && !!hostConfig.confirmationScreen.claimFormSections

  const handleBeginClaimForm = () => {
    const params = new URLSearchParams(routerLocation.search)
    params.set(QUERY_PARAMS.CLAIM_ID, reservation.id)
    params.set(QUERY_PARAMS.FLOW, FLOWS.CLAIM_FORM)
    navigate(`/?${params.toString()}`)
  }

  if (reservation.claimReservationDetails) {
    return (
      <>
        <Header title={'Schedule an Appointment'} />
        <section className={CLASS_NAME}>
          <ImageBackgroundSection backgroundUrl={DetailsBackground}>
            <section className={`${CLASS_NAME}__details-text`}>
              <p>Current Appointment</p>
              <h1>{`${dateInfo.dayOfWeek} ${dateInfo.month} ${dateInfo.dayOfMonth}${ComponentUtils.suffixForDateNumber(Number(dateInfo.dayOfMonth))} @ ${reservation.timeslot.display.localTime}`}</h1>
              <p>at the</p>
              <h3>{reservation.claimCenter.name}</h3>

              <section className={`${CLASS_NAME}__details-address`}>
                <p>{reservation.claimCenter.address1}</p>
                <p>{reservation.claimCenter.address2}</p>
                <p>
                  {reservation.claimCenter.city}, {reservation.claimCenter.region}{' '}
                  {reservation.claimCenter.postalCode}
                </p>
              </section>
            </section>
          </ImageBackgroundSection>
          <section className={`${CLASS_NAME}__cta-section`}>
            {showClaimFormCta && <Button onClick={handleBeginClaimForm}>Begin Claim Form</Button>}
            <Button
              onClick={() => {
                navigate(`/reschedule${location.search}`)
              }}>
              Reschedule
            </Button>
            <Button
              onClick={() => {
                navigate(`/delete${location.search}`)
              }}>
              Cancel
            </Button>
          </section>
        </section>
      </>
    )
  }
}
